import XImg from 'vux/src/components/x-img/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}
export default {
name: 'news',
components: {
XImg,Tab, TabItem,Scroller,
},
data () {
return {
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
NewsCategoryList: [],
NewsList: [],
classifyActive:0,
classifyId:'',
page: 1,
}
},
methods: {
getNewsCategory () {
this.$request.post('/news/listNewsCategory',{

}).then(data => {
if(data.code == 0){
this.NewsCategoryList = [...data.obj]
this.classifyId = data.obj[0].id
this.loadMore()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getNewsList (cb) {



this.$request.post('/news/listNewsByCategoryId',{
categoryId: this.classifyId,
page:this.page,
rows:10,
}).then(data => {
if(data.code == 0){
cb(data.obj.rows)


}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},

refresh() {
this.page = 1
this.getNewsList(data => {
this.NewsList = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
})
this.page += 1
},
loadMore() {
this.getNewsList(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.NewsList = this.NewsList.concat(data)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
},

changeCategory (id,index) {
this.NewsList= []
this.classifyActive == index?this.classifyActive = -1:this.classifyActive = index
this.classifyId = id
this.page = 1
this.loadMore()
},
newsDetail (item, index) {
this.$router.push({
path: '/newsDetail',
query: {
id: item.id
}
})
},
},
created () {


this.getNewsCategory()
},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/news/script.js